import { styled } from '@mui/system';
import { Theme } from '@mui/material';

import BoxMui from '@mui/material/Box';
import Tooltip from 'components/views/Tooltip';
import Typography from '@mui/material/Typography';

type ParamsStyle = {
    theme?: Theme;
}

type Params = {
    text: string;
    register: any;
    disabled?: boolean;
    display?: string;
    width?: string;
    listItems: Array<{
        id: string;
        name: string;
        value: string;
    }>;
    textTooltip?: string;
}

const Box = styled(BoxMui)(
    ({ theme }: ParamsStyle) => `
    text-align: left;
    display: flex;
    flex-direction: column;
    padding-bottom: 1.37rem;

    h6 {
        width: 100%;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        padding-bottom: 2.06rem;
    }
`)

const Container = styled('ul')(
    ({ theme }: ParamsStyle) => `
    margin: 0;
    padding: 0;
    gap: 14px;
    display: flex;
    list-style: none;
    overflow: hidden;
    min-width: 200px;    
    align-items: center;
    justify-content: center;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        gap: 30px;
    }

    li {
        margin: 0;
        width: 9.07rem;
        height: 1.875rem;
        display: flex;
        text-decoration: none;
    }
    
    input {
        clip: rect(0, 0, 0, 0);
        height: 1px;
        width: 1px;
        border: 0;
        overflow: hidden;
    }
    
    label {
        width: 9.07rem;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        
        line-height: 1;
        font-size: .8125rem;
        
        margin-right: -1px;
        border-radius: 100px;
        background-color: #FFFFFF;
        transition: all 0.1s ease-in-out;
        color: ${theme?.palette.grey[400]};
        border: 1.5px solid ${theme?.palette.grey[400]};
    }
    
    label:hover {
        cursor: pointer;
    }

    &.disabled {
        label:hover {
            cursor: default;
        }   
    }
    
    input:checked + label {
        color: #fff;
        font-weight: 700;
        background-color: ${theme?.palette.primary.main};

        &[aria-disabled="true"] {
            background-color: ${theme?.palette.grey[400]};
        }
    }
`)

const RadioButton = ({ text, listItems, register, textTooltip = '', disabled = false }: Params) => {
    return (
        <Box>
            <Typography variant="subtitle2" paddingBottom='1.25rem' textAlign='start'>
                {text}
                {textTooltip &&
                    <Tooltip>
                        <Typography fontSize='.625rem' color="inherit" fontWeight={600}>
                            {textTooltip}
                        </Typography>
                    </Tooltip>
                }
            </Typography>
            <Container className={disabled ? 'disabled' : 'active'}>
                {listItems.map(({ id, name, value }, index) => (
                    <li key={index}>
                        <input type="radio" id={id} name={name} value={value} {...register} disabled={disabled} />
                        <label htmlFor={id} aria-disabled={disabled}>{value}</label>
                    </li>
                ))}
            </Container>
        </Box>
    );
}

export default RadioButton;